import axios from 'axios'

export async function locateCountry() {
  const { data } = await axios.get('https://ip2c.org/s')
  const [status, countryCode] = data.split(';')
  if (status === '1') {
    return countryCode
  }
}
